/**
 * Builds the URL path for fetching Codespaces content
 * @param repoId - The repository ID
 * @param createRef - The ref or commitish used for create actions
 * @returns The encoded URL path for Codespaces
 */
export function buildCodespacesPath(
  repoId: number,
  createRef: string,
  options?: {currentBranchName?: string; pullRequestId?: number},
): string {
  const params = new URLSearchParams({
    event_target: 'REPO_PAGE',
    repo: String(repoId),
  })

  if (options?.pullRequestId != null) {
    params.set('codespace[pull_request_id]', String(options.pullRequestId))
  } else {
    params.set('codespace[ref]', createRef)
  }

  const currentBranchName = options?.currentBranchName ?? (options?.pullRequestId == null ? createRef : undefined)
  if (currentBranchName) {
    params.set('current_branch', currentBranchName)
  }

  return `/codespaces?${params.toString()}`
}
